import { useCallback, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { checkEmailExists } from "../../behavior/api/auth";
import { PageRoute, PageState } from "../../constants";
import TransitionPage from "../../pages/transition/TransitionPage";
import { useMyHubertSession } from "./useMyHubertSession";

const PostInstantApply = () => {
    const navigate = useNavigate();
    const shouldExecuteRef = useRef(true);
    const [params] = useSearchParams();
    const { sessionToken, logoutUser } = useMyHubertSession();

    const processEmail = useCallback(async () => {
        const email = params.get("email");
        const token = params.get("token");
        const job = params.get("job");
        const candidate = params.get("candidate");

        if (sessionToken && sessionToken.user !== null) {
            const candidateEmail = sessionToken.user?.email;
            if (email !== candidateEmail) {
                await logoutUser();
            } else {
                navigate(`${PageRoute.DASHBOARD}?state=${PageState.INTERVIEW_COMPLETED}`);
                return;
            }
        } else if (email && job && candidate) {
            const emailCheck = await checkEmailExists(email);
            let signInOrSignUpUrl = new URL(
                `${PageRoute.INSTANT_APPLY.INDEX}/${PageRoute.INSTANT_APPLY.POST_INTERVIEW_SIGNUP}/?state=${PageState.JOB_APPLY_POST_INTERVIEW_SIGN_UP}`,
                window.location.origin,
            );

            if (emailCheck.exists) {
                signInOrSignUpUrl = new URL(
                    `${PageRoute.INSTANT_APPLY.INDEX}/${PageRoute.INSTANT_APPLY.POST_INTERVIEW_SIGNIN}/?state=${PageState.JOB_APPLY_POST_INTERVIEW_SIGN_IN}`,
                    window.location.origin,
                );
            }

            signInOrSignUpUrl.searchParams.set("email", email);
            signInOrSignUpUrl.searchParams.set("job", job);
            signInOrSignUpUrl.searchParams.set("candidate", candidate);
            if (token) signInOrSignUpUrl.searchParams.set("token", token);

            navigate(`${signInOrSignUpUrl.pathname}${signInOrSignUpUrl.search}`);
        }
    }, [sessionToken, logoutUser, navigate, params]);

    useEffect(() => {
        if (!shouldExecuteRef.current) {
            return;
        }
        shouldExecuteRef.current = false;
        processEmail();
    }, [processEmail]);

    return <TransitionPage />;
};

export default PostInstantApply;
